module.exports = __webpack_public_path__ + "img/what-we-do.c358712d.jpg";